import icons from 'url:../../img/icons.svg'


export default class View{
    _data;

    _clear()
    {
        this._parentElement.innerHTML = '';
    }

    render(data , render = true){
        if(!data || (Array.isArray(data) && data.length === 0)) return this.renderError();
        this._data = data;
        const markup = this._generateMarkup();

        if(!render) return markup;
        this._clear();
        this._parentElement.insertAdjacentHTML('afterbegin' , markup);
    }

    update(data)
    {
        if(!data || (Array.isArray(data) && data.length === 0)) return this.renderError();
        this._data = data;
        const newMarkup = this._generateMarkup();

        const newDom = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDom.querySelectorAll('*'));
        const curElements = Array.from(this._parentElement.querySelectorAll('*'));

        newElements.forEach((newEl , i)=>{
            if(i >= curElements.length) return;
            // Update Changed Texts
            if(!newEl.isEqualNode(curElements[i]) && newEl.firstChild?.nodeValue.trim() !== ''){
                curElements[i].textContent = newEl.textContent;
            }

            // Updates changed Attrs
            if(!newEl.isEqualNode(curElements[i])){
                Array.from(newEl.attributes).forEach(attr=> curElements[i].setAttribute(attr.name , attr.value));
            }
        })
    }

    renderSpiner()
    {
        const markup = `
            <div class="spinner">
                <svg>
                    <use href="${icons}#icon-loader"></use>
                </svg>
            </div>
        `
        this._clear();
        this._parentElement.insertAdjacentHTML('afterbegin' , markup);
    }

    renderError(message = this._errorMessage)
    {
        const markup = `
            <div class="error">
            <div>
              <svg>
                <use href="${icons}#icon-alert-triangle"></use>
              </svg>
            </div>
            <p>${message}</p>
          </div>
        `
        this._clear();
        this._parentElement.insertAdjacentHTML('afterbegin' , markup);
    }

    
    renderMessage(message = this._message)
    {
        this._clear();
        const markup = `
            <div class="message">
                <div>
                    <svg>
                    <use href="${icons}#icon-smile"></use>
                    </svg>
                </div>
                <p>${message}</p>
            </div>
        `
        this._parentElement.insertAdjacentHTML('afterbegin' , markup);
    }
}